import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { PermissionService } from './../../service/permission.service';
import { ObjectNames } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class LocationguardService  {

  constructor(private permissionService: PermissionService,private messageService: MessageService,
    private router: Router) { }

  canActivate(): boolean {
        
    const userPermissions = this.permissionService.getPemrissionData();
    const locationModulePermissions = userPermissions.find(obj => obj.objectName == ObjectNames.warehouseConstants.ModuleName);
    const locationMenuPermission = locationModulePermissions ? (locationModulePermissions.permissions.find(obj => obj.statusId == 1) ? true : false) : false;


    if(!locationMenuPermission){
      this.router.navigate(["**"]);  
        this.messageService.add({ severity: 'error', summary: 'Error', detail: `You don't have permission to access Location module.` });
    }
    return locationMenuPermission;
}
}
